var React = require('react');

function LogoWindowsInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.5749 2.66827C21.7075 1.73224 27.8518 0.850583 33.9961 0C34 5.37149 33.9961 10.7391 34 16.1106C27.8596 16.1339 21.7192 16.2271 15.5749 16.2465C15.571 11.7178 15.571 7.19305 15.5749 2.66827ZM0 4.8355C4.61796 4.12474 9.25577 3.51108 13.8932 2.93237C13.8971 7.38725 13.8971 11.8382 13.901 16.2931C9.26745 16.2892 4.63353 16.3592 0 16.3475V4.8355ZM0 17.7496C4.63003 17.7341 9.25928 17.8079 13.8889 17.8001C13.8889 22.2666 13.9006 26.7332 13.8932 31.1997C9.26745 30.5157 4.63353 29.918 0 29.2927V17.7496ZM15.5476 17.9283H33.9961C34.0039 23.2842 33.9961 28.6402 33.9961 34C27.8635 33.0834 21.7192 32.2328 15.5749 31.402C15.5671 26.9118 15.5554 22.422 15.5476 17.9283Z","fill":"white"}));
}

LogoWindowsInline.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = LogoWindowsInline;

LogoWindowsInline.default = LogoWindowsInline;
